export default __webpack_public_path__ + "static/media/Custom3.d03166c4.png";